"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = TimesSummaryTab;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const CommonComponents_1 = require("../../View/Resultsets/CommonComponents");
const ScrumboardApi_1 = __importDefault(require("../ScrumboardApi"));
const useScrumboardEvents_1 = require("../useScrumboardEvents");
const fmt = (n) => (Number.isInteger(n) ? String(n) : n.toFixed(1));
/** Podsumowanie godzin — odpowiednik tabeli "Times summary" z arkusza. */
function TimesSummaryTab({ active }) {
    const [rows, setRows] = (0, react_1.useState)([]);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [error, setError] = (0, react_1.useState)(null);
    async function load() {
        try {
            setRows(await ScrumboardApi_1.default.getTimesSummary());
        }
        catch (err) {
            setError(err instanceof Error ? err.message : String(err));
        }
        finally {
            setLoading(false);
        }
    }
    // Przeładuj przy wejściu na zakładkę (dane mogły się zmienić na innych zakładkach)
    (0, react_1.useEffect)(() => {
        if (active !== false)
            load();
    }, [active]);
    // Odśwież przy zmianach wpływających na godziny
    (0, useScrumboardEvents_1.useScrumboardEvents)({
        "task-hours-changed": load,
        "hours-reset": load,
        "planning-changed": load,
        "task-status-changed": load,
    }, load);
    if (loading)
        return react_1.default.createElement(CommonComponents_1.SpinnerBootstrap, null);
    if (error)
        return (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger", dismissible: true, onClose: () => setError(null) }, error));
    return (react_1.default.createElement(react_bootstrap_1.Table, { striped: true, bordered: true, hover: true, size: "sm", responsive: true },
        react_1.default.createElement("thead", null,
            react_1.default.createElement("tr", null,
                react_1.default.createElement("th", null, "Osoba"),
                react_1.default.createElement("th", null, "Dost\u0119pne"),
                react_1.default.createElement("th", null, "Przypisano"),
                react_1.default.createElement("th", null, "PON."),
                react_1.default.createElement("th", null, "WTO."),
                react_1.default.createElement("th", null, "\u015AR."),
                react_1.default.createElement("th", null, "CZW."),
                react_1.default.createElement("th", null, "PT."),
                react_1.default.createElement("th", null, "Spotkania"),
                react_1.default.createElement("th", null, "Razem"),
                react_1.default.createElement("th", null, "Pozosta\u0142o"))),
        react_1.default.createElement("tbody", null, rows.map((r) => (react_1.default.createElement("tr", { key: r.personId },
            react_1.default.createElement("td", null, r.personName),
            react_1.default.createElement("td", null, fmt(r.available)),
            react_1.default.createElement("td", null, fmt(r.assigned)),
            react_1.default.createElement("td", null, fmt(r.mon)),
            react_1.default.createElement("td", null, fmt(r.tue)),
            react_1.default.createElement("td", null, fmt(r.wed)),
            react_1.default.createElement("td", null, fmt(r.thu)),
            react_1.default.createElement("td", null, fmt(r.fri)),
            react_1.default.createElement("td", null, fmt(r.meetings)),
            react_1.default.createElement("td", null, fmt(r.total)),
            react_1.default.createElement("td", { className: r.remaining < 0 ? "text-danger fw-semibold" : "" }, fmt(r.remaining))))))));
}
